import { useState, useEffect } from 'react';

import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

import { restoreApis } from '../../../apis/restoreApis';
import Loading from '../../../components/elements/loading/Loading';
import RestoreTable from '../../../components/page-sections/backup-restore/restore-table/RestoreTable';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { handleErrors } from '../../../helpers';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import { sentenceCase } from '../../../utils/utils';

const ProjectRestorePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const { showToast } = useToast();

  const [loading, setLoading] = useState(true);
  const [restoreList, setRestoreList] = useState(null);

  const getRestoreList = async () => {
    const { data } = await restoreApis.getRestores(projectId);
    setRestoreList(data);
  };

  const handleDelete = async (restoreId) => {
    try {
      await restoreApis.deleteRestore(projectId, restoreId);
      showToast(
        TOAST_TYPE.SUCCESS,
        sentenceCase(
          t('deleteSuccess', {
            ns: 'notifications',
            text: t('backup.restoreData', { ns: 'project' }),
          })
        )
      );

      await getRestoreList();
    } catch (error) {
      showToast(
        TOAST_TYPE.ERROR,
        sentenceCase(
          t('deleteError', {
            ns: 'notifications',
            text: t('backup.restoreData', { ns: 'project' }),
          })
        )
      );
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      await getRestoreList();
    } catch (error) {
      handleErrors(navigate, error, showToast);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Container>
      {loading && <Loading />}
      {!loading && (
        <>
          <Breadcrumbs />
          <TitlePanel title={t('restore', { ns: 'titles' })} />
          <RestoreTable restoreList={restoreList} handleDelete={handleDelete} />
        </>
      )}
    </Container>
  );
};

export default ProjectRestorePage;
